




















































import Vue from 'vue';
import LanguageSelection from '@/components/header/subcomponents/LanguageSelection.vue';
import Searchbox from '@/components/searchbox/Searchbox.vue';
import MyAccount from '@/components/header/subcomponents/MyAccount.vue';
import { IIcons } from '@/common/interfaces/index.interface';
import { IMenuItem, IMenus, IHeaderDesktopComponent } from '@/common/interfaces/header.interface';
import Topic from './Topic.vue';
import TIcons from '../../../types/TIcons';
import config from '../../../../config';

export default Vue.extend({
  name: `HeaderDesktop`,
  components: {
    LanguageSelection,
    MyAccount,
    Searchbox,
    Topic,
  },
  data(): IHeaderDesktopComponent {
    return {
      cartLink: ``,
      loginLink: ``,
    };
  },
  computed: {
    logo(): string {
      return this.isPartnerShop ? TIcons.ringanaLogoPartner : TIcons.ringanaLogo;
    },
    topics(): IMenuItem[] {
      return this.loggedIn && !this.isPartner
        ? this.menus.loggedInCustomer
        : this.menus.loginAndCart;
    },
  },
  props: {
    cartItemsCount: {
      required: true,
      type: Number,
    },
    chosenLanguage: {
      required: true,
      type: String,
    },
    icons: {
      required: true,
      type: Object as () => IIcons,
    },
    isPartner: {
      required: true,
      type: Boolean,
    },
    isPartnerShop: {
      required: true,
      type: Boolean,
    },
    languages: {
      required: true,
      type: Array as () => string[],
    },
    loading: {
      required: true,
      type: Boolean,
    },
    loggedIn: {
      required: true,
      type: Boolean,
    },
    menus: {
      required: true,
      type: Object as () => IMenus,
    },
  },
  mounted(): void {
    this.initAccountLinks();
  },
  methods: {
    initAccountLinks(): void {
      const cartLinks: {[index: string]: string} = config.header.links.cart;
      const loginLinks: {[index: string]: string} = config.header.links.login;

      this.cartLink = cartLinks[this.chosenLanguage];
      this.loginLink = loginLinks[this.chosenLanguage];
    },
    switchLanguage(code: string): void {
      this.$emit(`change:language`, code);
    },
  },
});
